import { Chip, Stack, Typography } from '@mui/material';
import { customerActivityLabels } from '@/features/operations/labels';
import type { CustomerActivity } from '@/features/customers/types';

/** One chip per thing the person did; a dash-free sentence when there is nothing yet. */
export function CustomerActivityChips({ activity }: { activity: CustomerActivity }) {
  const done = (Object.keys(customerActivityLabels) as (keyof CustomerActivity)[]).filter(
    (key) => activity[key],
  );

  if (!done.length) {
    return (
      <Typography variant="body2" color="text.secondary">
        Sin actividad
      </Typography>
    );
  }

  return (
    <Stack direction="row" spacing={0.5} sx={{ flexWrap: 'wrap', rowGap: 0.5 }}>
      {done.map((key) => (
        <Chip key={key} size="small" variant="outlined" label={customerActivityLabels[key]} />
      ))}
    </Stack>
  );
}
